import {useTheme} from '@mui/material';
import {type GridRowId} from '@mui/x-data-grid';
import {useState} from 'react';

type UseDialogControlsReturn<T> = {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedData?: T;
  onOpen: (id: GridRowId) => () => void;
  reset: () => void;
};
const useDialogControls = <T extends { id: string }>(data: Array<T>): UseDialogControlsReturn<T> => {
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState<T>();
  const theme = useTheme();

  const onOpen = (id: GridRowId) => () => {
    setSelectedData(data.find((c) => c.id === id));
    setOpen(true);
  };
  const reset = () => {
    setOpen(false);
    setTimeout(() => setSelectedData(undefined), theme.transitions.duration.leavingScreen);
  };

  return {
    open,
    setOpen,
    selectedData,
    onOpen,
    reset,
  };
};

export default useDialogControls;
